var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZohoCrm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.3655,13.9999c5.1292-2.9937,11.671-1.5275,15.068,3.377,3.3971,4.9046,2.5225,11.62-2.0145,15.469-4.537,3.8486-11.231,3.5531-15.419-.6806l-8.077-8.1653c-1.1152-1.1274-1.1152-2.9552,0-4.0827,1.1152-1.1274,2.9233-1.1274,4.0385,0l8.077,8.1653c1.1152,1.1274,2.9233,1.1274,4.0385,0s1.1152-2.9552,0-4.0827l-8.077-8.1653c-4.188-4.2337-10.882-4.5292-15.419-.6806-4.537,3.8487-5.4116,10.564-2.0145,15.469,3.3971,4.9046,9.9389,6.3707,15.068,3.377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZohoCrm);
export default __webpack_public_path__ + "static/media/zoho_crm.8fc50ef7489a8e730f6c43fe802a4522.svg";
export { ForwardRef as ReactComponent };